export const omdbAPIMessage = 'omdbAPIMessage'
export const newMoviesList  = 'newMoviesList'
export const newMovieDetail = 'newMovieDetail'
export const newPerfMetric  = 'newPerfMetric'